import { render, staticRenderFns } from "./QuickView.vue?vue&type=template&id=3b8261a4&scoped=true&"
import script from "./QuickView.vue?vue&type=script&lang=js&"
export * from "./QuickView.vue?vue&type=script&lang=js&"
import style0 from "./QuickView.vue?vue&type=style&index=0&id=3b8261a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8261a4",
  null
  
)

export default component.exports